import api from "!../../../NodeModules/Ljbc/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../NodeModules/Ljbc/node_modules/css-loader/index.js!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../NodeModules/Ljbc/node_modules/postcss-loader/src/index.js??postcss!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/index.js??vue-loader-options!./ListView2.vue?vue&type=style&index=0&lang=css&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};